import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Barbearia from "@/pages/Barbearia";
import Clube from "@/pages/Clube";
import ProteseCapilar from "@/pages/ProteseCapilar";
import ProteseCidade from "@/pages/ProteseCidade";
import Resultados from "@/pages/Resultados";
import Unidades from "@/pages/Unidades";
import Depoimentos from "@/pages/Depoimentos";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import Duvidas from "@/pages/Duvidas";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Politica from "@/pages/Politica";
import Termos from "@/pages/Termos";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AuthCallback from "@/pages/admin/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return BEFORE anything else (read hash from router, it's reactive).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/barbearia" element={<Barbearia />} />
        <Route path="/clube" element={<Clube />} />
        <Route path="/protese-capilar" element={<ProteseCapilar />} />
        <Route path="/protese-capilar-arapiraca" element={<ProteseCidade slug="arapiraca" />} />
        <Route path="/protese-capilar-garanhuns" element={<ProteseCidade slug="garanhuns" />} />
        <Route path="/protese-capilar-maceio" element={<ProteseCidade slug="maceio" />} />
        <Route path="/resultados" element={<Resultados />} />
        <Route path="/unidades" element={<Unidades />} />
        <Route path="/depoimentos" element={<Depoimentos />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/duvidas" element={<Duvidas />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/politica-de-privacidade" element={<Politica />} />
        <Route path="/termos-de-uso" element={<Termos />} />
      </Route>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
